import _ from 'lodash';

export const calculateHourDifference = () => {
  const secondsInHour = 3600;
  const msInSecond = 1000;
  const timeSaved = localStorage.getItem('LooptijdRenteExpiration');
  const timeNow = new Date().getTime();

  const difference = timeNow - timeSaved;
  const hourDifference = difference / secondsInHour / msInSecond;
  return hourDifference;
};

export const setItemLocalStorage = (keyValue, keyName) => {
  if (localStorage) {
    localStorage.setItem(keyName, JSON.stringify(keyValue));
    localStorage.setItem('LooptijdRenteExpiration', new Date().getTime());
  }
};

export const getItemFromLocalStorage = (keyName) => {
  let itemFromStorage = {};

  const hourDifference = calculateHourDifference();

  if (hourDifference <= 3 && localStorage) {
    itemFromStorage = JSON.parse(localStorage.getItem(keyName));
  }

  return itemFromStorage;
};


export const getFormDataFromStorage = (formData) => {
  const formName = 'LooptijdRenteForm';
  if (getItemFromLocalStorage(formName)
    && _.isEmpty(formData.mortgage)) {
    formData = getItemFromLocalStorage(formName);
  }

  // Set default mortgageType
  formData.mortgageType = 6;

  return formData;
};
